import React from 'react';
export const MeshView = () => {
  return <div className="p-2" data-id="element-591">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-592">
        Mesh Settings
      </h2>
      <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6" data-id="element-593">
        <div className="flex justify-between items-start mb-6" data-id="element-594">
          <div data-id="element-595">
            <h3 className="text-xl font-medium text-gray-800" data-id="element-596">Hogan Mesh</h3>
            <p className="text-sm text-gray-600 mt-1" data-id="element-597">
              13 active nodes, 1 inactive node
            </p>
          </div>
          <div className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full font-medium" data-id="element-598">
            Connected
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-599">
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50" data-id="element-600">
            <div className="flex justify-between items-center mb-2" data-id="element-601">
              <h4 className="font-medium text-gray-700" data-id="element-602">Node Status</h4>
            </div>
            <div className="flex items-center gap-2" data-id="element-603">
              <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-604"></div>
              <span className="text-sm text-gray-600" data-id="element-605">13 Active</span>
            </div>
            <div className="flex items-center gap-2 mt-1" data-id="element-606">
              <div className="w-3 h-3 rounded-full bg-gray-300" data-id="element-607"></div>
              <span className="text-sm text-gray-600" data-id="element-608">1 Inactive</span>
            </div>
          </div>
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50" data-id="element-609">
            <div className="flex justify-between items-center mb-2" data-id="element-610">
              <h4 className="font-medium text-gray-700" data-id="element-611">Network Health</h4>
            </div>
            <div className="flex items-center gap-2" data-id="element-612">
              <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-613"></div>
              <span className="text-sm text-gray-600" data-id="element-614">Healthy</span>
            </div>
            <div className="flex items-center gap-2 mt-1" data-id="element-615">
              <div className="w-3 h-3 rounded-full bg-blue-500" data-id="element-616"></div>
              <span className="text-sm text-gray-600" data-id="element-617">
                Last updated 5 minutes ago
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex gap-3" data-id="element-618">
        <button className="px-4 py-2 bg-teal-500 text-white rounded-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2" data-id="element-619">
          Create Mesh
        </button>
        <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400" data-id="element-620">
          Connect Mesh
        </button>
      </div>
    </div>;
};